import { render } from "./text-styler-parent-regular.vue?vue&type=template&id=588048f0"
import script from "./text-styler-parent-regular.vue?vue&type=script&lang=js"
export * from "./text-styler-parent-regular.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__